import { useRef } from 'react'
import { GoogleMap, Marker, Circle } from '@react-google-maps/api'
import { useTheme } from '@mui/material'
import Geocode from 'react-geocode'

import { handleMapTypeIdChange } from 'src/constants'
import { useStyles } from './styles'

interface IFormGoogleMap {
  handleLatAndLong: (latAndLong: { lat: number; lng: number }) => void
  handleAddress: (address: string) => void
  isDisabled?: boolean
  center: {
    lat: number
    lng: number
  }
  radius?: number
}

const FormGoogleMap = ({
  handleLatAndLong,
  handleAddress,
  center,
  radius,
  isDisabled,
}: IFormGoogleMap) => {
  const mapRef = useRef<google.maps.Map | null>(null)

  const theme = useTheme()
  const classes = useStyles()

  const handleMarker = async (e: google.maps.MapMouseEvent) => {
    if (isDisabled) return
    if (!e.latLng) return
    const lat = e.latLng.lat()
    const lng = e.latLng.lng()
    handleLatAndLong({ lat, lng })
    const address = await Geocode.fromLatLng(String(lat), String(lng))
    address?.results?.[0]?.formatted_address && handleAddress(address.results[0].formatted_address)
  }

  const handleLoad = (map: google.maps.Map) => {
    mapRef.current = map
    handleMapTypeIdChange(map)
  }

  return (
    <GoogleMap
      mapContainerClassName={classes.root}
      center={center}
      options={{ streetViewControl: false }}
      zoom={14}
      onClick={handleMarker}
      onLoad={handleLoad}
      onMapTypeIdChanged={() => {
        handleMapTypeIdChange(mapRef?.current)
      }}
    >
      <Marker position={center} options={{ draggable: true }} onDragEnd={handleMarker} />
      {radius && (
        <Circle
          center={center}
          options={{
            radius,
            visible: true,
            strokeWeight: 0,
            fillOpacity: 0.3,
            clickable: false,
            draggable: false,
            editable: false,
            fillColor: theme.palette.custom.primary,
            zIndex: 1,
          }}
        />
      )}
    </GoogleMap>
  )
}

export { FormGoogleMap }
